/** Official 2026 hunt window. Day count is derived, never stored as a fixed number. */
export const HUNT_DEPART = "2026-10-02";
export const HUNT_END = "2026-10-09";
export const STAY_DAYS = ["2026-10-02", "2026-10-03", "2026-10-04", "2026-10-05", "2026-10-06", "2026-10-07", "2026-10-08", "2026-10-09"];

export function phaseForIso(iso) {
  if (iso < HUNT_DEPART) return "prep";
  if (iso === HUNT_DEPART) return "depart";
  if (iso <= HUNT_END) return "hunt";
  return "after";
}

export function stayState(iso, anchor) {
  if (iso === anchor) return "today";
  if (iso < anchor) return "past";
  return "future";
}

export function dayNumberFromIso(iso) {
  const [year, month, day] = String(iso || "").split("-").map(Number);
  if (!year || !month || !day) return 1;
  return Math.round((Date.UTC(year, month - 1, day) - Date.UTC(2026, 9, 2)) / 86400000) + 1;
}

export function daysUntilHuntDepart(now = new Date()) {
  const target = Date.UTC(2026, 9, 2);
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((target - today) / 86400000);
}

function utcDay(now) {
  return Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
}

/** prep before 2 Oct, hunt from 2 through 9, after from 10. */
export function huntPhase(now = new Date()) {
  const day = utcDay(now);
  if (day < Date.UTC(2026, 9, 2)) return "prep";
  if (day > Date.UTC(2026, 9, 9)) return "after";
  return "hunt";
}

/** Companion phases: prep, departure day, hunt days, then the bilan. */
export function companionPhase(now = new Date()) {
  const day = utcDay(now);
  if (day < Date.UTC(2026, 9, 2)) return "prep";
  if (day === Date.UTC(2026, 9, 2)) return "depart";
  if (day <= Date.UTC(2026, 9, 9)) return "hunt";
  return "after";
}

export function phaseDate(phase, now = new Date()) {
  if (phase === "depart") return "2026-10-02";
  if (phase === "hunt") return "2026-10-03";
  if (phase === "after") return "2026-10-10";
  return isoDate(now);
}

/** 2 Oct is day 1. */
export function huntDayNumber(now = new Date()) {
  return Math.round((utcDay(now) - Date.UTC(2026, 9, 2)) / 86400000) + 1;
}

/** Phone-setup block stays through the Saturday after arrival (3 Oct). */
export function showNordQuestSetup(now = new Date()) {
  return utcDay(now) <= Date.UTC(2026, 9, 3);
}

const SUPPER_DATES = ["2026-10-02", "2026-10-03", "2026-10-04", "2026-10-05", "2026-10-06", "2026-10-07"];

export function supperIndexForDate(iso) {
  const index = SUPPER_DATES.indexOf(iso);
  return index >= 0 ? index : -1;
}

export function torontoClock(iso) {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat("fr-CA", {
    timeZone: "America/Toronto",
    hour: "numeric",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  const hour = parts.find((part) => part.type === "hour")?.value || "";
  const minute = parts.find((part) => part.type === "minute")?.value || "00";
  return `${hour} h ${minute}`;
}

export function localStampClock(stamp) {
  if (!stamp || String(stamp).length < 16) return "—";
  const [hour, minute] = String(stamp).slice(11, 16).split(":");
  return `${Number(hour)} h ${minute}`;
}

export function syncWhen(iso, now = new Date()) {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const clock = torontoClock(iso);
  const format = (value) => new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Toronto", year: "numeric", month: "2-digit", day: "2-digit",
  }).format(value);
  const day = format(date);
  if (day === format(now)) return clock;
  if (day === format(new Date(now.getTime() - 86400000))) return `hier ${clock}`;
  return `${day} ${clock}`;
}

export function inHuntStay(now = new Date()) {
  const iso = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Toronto", year: "numeric", month: "2-digit", day: "2-digit",
  }).format(now);
  return iso >= "2026-10-02" && iso <= "2026-10-09";
}

export function isoDate(now = new Date()) {
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}
